import React from 'react';
import { useEditMode } from '@/contexts/EditModeContext';
import { Link } from 'react-router-dom';
import { HStack } from '@/components/core';

export const InlineEditHintBar: React.FC = () => {
  const { isEditMode, setEditMode, canEdit } = useEditMode();
  if (!canEdit || !isEditMode) return null;

  return (
    <div className="fixed bottom-token-md left-token-md z-50">
      <div className="rounded-token-sm border border-white/10 bg-background/90 backdrop-blur px-token-sm py-token-sm text-xs text-muted-foreground shadow-token-card">
        <HStack align="center" gap="sm">
          <span className="inline-flex h-4 w-4 items-center justify-center rounded-token-sm border border-white/20 text-[10px]">✎</span>
          <span>Inline-Edit aktiv. Klicke markierte Texte zum Bearbeiten.</span>
        </HStack>
        <HStack align="center" gap="sm" className="mt-token-sm">
          <Link to="/admin/text-overrides" className="underline">
            UI Text Overrides öffnen
          </Link>
          <button
            type="button"
            className="ml-auto rounded border border-white/10 px-2 py-0.5 hover:bg-white/5"
            onClick={() => setEditMode(false)}
          >
            Deaktivieren
          </button>
        </HStack>
      </div>
    </div>
  );
};





